export default __webpack_public_path__ + "static/media/pe.ccfc3234.svg";